module.exports = __webpack_public_path__ + "static/media/megaphone.28ebcf5d.png";